import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import { SelectBox, TextArea} from 'devextreme-react';
import { useDispatch, useSelector } from "react-redux";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors";
import { factoryActive } from "../../../../../Constantes/factoryActive";
import { getLetterTypes } from "../../../../../redux/documentationTemplates/thunks";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { selectLetterTypes } from "../../../../../redux/documentationTemplates/selectors";

function InputWrapper(props){
const {classes, label} = props;
    return(
        <div className="dx-field">
        <label className={classes.label}>{label}</label> 
            <div style={{width:"100%"}} className="dx-field-value">
                {props.children}
            </div>
    </div>
    )
}

function LetterQueryForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const [type, setType] = useState(dataForm?.templateCode);
const letterTypes = useSelector(selectLetterTypes);



useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}));
},[])

useEffect(()=>{
    dispatch(getLetterTypes());
},[])

useEffect(()=>{
    if(types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
        setType(types[0].id);
    }
},[type, types])

function getTemplateIdFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.id
    }
}

function setNotes(value){
    const filteredText = deleteStrangeCharacters(value); 
    onChange("notes", filteredText)
}

function setLetterType(value){
    if(value){
        onChange("letterType", value);
        onChange("subtype", template.code+"_"+value)
        setNotes(letterTypes.find(x=>x.code == value)?.notes );
    }
}

    return(
        <div className={classes.containers} id="documentation-request-form">
            <InputWrapper classes={classes} label={"Tipo de carta"}>
                <SelectBox valueExpr={"code"} displayExpr="name"  
                    key={"code"} name="code" 
                    value={dataForm?.letterType}
                    className={classes.controlers} 
                    height={25} 
                    onValueChanged={(e) => { setLetterType(e.value)}} 
                    placeholder="" 
                    dataSource={letterTypes} 
                    noDataText={"Nenhuma opção disponível"}
                 />
            </InputWrapper>
            <InputWrapper classes={classes} label={"Notas"}>
                <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
            </InputWrapper>
        </div>
    )
}

export { LetterQueryForm }